export default __webpack_public_path__ + "static/psle-slay-screen-4-5f3492c6db477e5d2ea16a126709de98.png";